import { render } from "./TeacherTraining.vue?vue&type=template&id=0332507b&scoped=true"
import script from "./TeacherTraining.vue?vue&type=script&lang=js"
export * from "./TeacherTraining.vue?vue&type=script&lang=js"

import "./TeacherTraining.vue?vue&type=style&index=0&id=0332507b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0332507b"]])

export default __exports__